/** User-facing labels for permission claim codes (mirrors server PermissionDefinitions). */
export interface PermissionDisplayInfo {
  name: string;
  description: string;
}

export const PERMISSION_DISPLAY: Record<string, PermissionDisplayInfo> = {
  'iq.Tile.AdminPortal.VIEW': {
    name: 'View',
    description: 'Open the administration portal from IQ Connect.',
  },
  'iq.Patients.List.VIEW': {
    name: 'View',
    description: 'Open and browse the patient list.',
  },
  'iq.Patients.List.WRITE': {
    name: 'Write',
    description: 'Add or update a patient record.',
  },
  'iq.Protocol.List.VIEW': {
    name: 'View',
    description: 'Open and browse the protocol list and protocol details.',
  },
  'iq.Protocol.List.WRITE': {
    name: 'Write',
    description: 'Create or update a protocol.',
  },
  'iq.Account.Profile.VIEW': {
    name: 'View',
    description: 'View your account profile.',
  },
  'iq.Treatment.Profile.Documents_VIEW': {
    name: 'View documents',
    description: 'See documents attached to the treatment profile.',
  },
  'iq.Treatment.Profile.Documents_WRITE': {
    name: 'Write documents',
    description: 'Add documents to the treatment profile.',
  },
  'iq.Treatment.Profile.Documents_DELETE': {
    name: 'Remove documents',
    description: 'Delete documents from the treatment profile.',
  },
  'iq.Treatment.Profile.Cases_VIEW': {
    name: 'View cases',
    description: 'See patient cases on the treatment profile.',
  },
  'iq.Treatment.Profile.Cases_WRITE': {
    name: 'Write cases',
    description: 'Open or close patient cases.',
  },
  'iq.Treatment.Profile.Cases_SOAP_NOTES_VIEW': {
    name: 'View SOAP notes',
    description: 'See SOAP notes on encounters.',
  },
  'iq.Treatment.Profile.Cases_SOAP_NOTES_WRITE': {
    name: 'Write SOAP notes',
    description: 'Add or update SOAP notes on encounters.',
  },
  'iq.Treatment.Profile.Referrals_VIEW': {
    name: 'View referrals',
    description: 'See referrals on the treatment profile.',
  },
  'iq.Treatment.Profile.Referrals_WRITE': {
    name: 'Write referrals',
    description: 'Update referrals on the treatment profile.',
  },
  'iq.Treatment.Profile.Results_VIEW': {
    name: 'View treatment results',
    description: 'See results of patient treaments.',
  },
  'iq.Treatment.Profile.TREAT': {
    name: 'Treat',
    description: 'Perform treatments on a patient.',
  },
  'iq.Treatment.Profile.TREATMENT_REVIEW': {
    name: 'Review treatment',
    description: 'Review completed treatments.',
  },
  'iq.Treatment.Profile.TREATMENT_DUPLICATE': {
    name: 'Duplicate treatment',
    description: 'Create a copy of an existing treatment.',
  },
  'iq.Treatment.Profile.TREATMENT_RECALL': {
    name: 'Recall treatment',
    description: 'Recall a previously completed treatment.',
  },
  'iq.Treatment.Profile.TREATMENT_EDIT': {
    name: 'Edit treatment',
    description: "Edit a previously completed treatment.",
  },
  'iq.Treatment.Profile.TREATMENT_PART_FINDINGS_WRITE': {
    name: 'Write treatment findings',
    description: 'Record findings for treatment parts.',
  },
  'iq.Treatment.Adjust.ONLINE_ADJUST': {
    name: 'Online adjustment',
    description: 'Connect to the IQ device from a web browser during treatment adjustment.',
  },
};

export function permissionDisplayName(code: string): string | undefined {
  return PERMISSION_DISPLAY[code]?.name;
}

export function permissionDisplayDescription(code: string): string | undefined {
  return PERMISSION_DISPLAY[code]?.description;
}
